import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {InputText, InputCheckBox} from 'js/components/form';
import styles from 'css/screens/registration.css';

@observer
/**
 * Form
 */
export default class Form extends Component {
  /**
   * constructor
   */
  constructor() {
    super();
    this.change = this.change.bind(this);
  }

  /**
   * change form
   * @param {object} e element
   */
  change(e) {
    const {
      name,
      type,
      value = null,
      checked = null,
    } = e.target;

    this.props.RegistrationStore.updateForm(
      name,
      ('checkbox' == type ? checked : value)
    );
  }

  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    const {
      RegistrationStore: store,
    } = this.props;

    const errors = {};
    (Object.keys(store.error)).forEach((key) => {
      errors[key] = null;

      if (store.error[key]) {
        errors[key] = (
          <div className={styles.error}>{store.error[key]}</div>
        );
      }
    });

    return (
      <div className={`${styles.block} ${styles.form}`}>
        <table>
          <tbody>
            <tr>
              <th>会社名</th>
              <td>
                <InputText
                  name="company"
                  placeholder="ビルコム株式会社"
                  value={store.form.company}
                  onChange={this.change}
                />
                {errors.company}
              </td>
            </tr>
            <tr>
              <th>部署名</th>
              <td>
                <InputText
                  name="unit"
                  placeholder="営業管理部"
                  value={store.form.unit}
                  onChange={this.change}
                />
                {errors.unit}
              </td>
            </tr>
            <tr className={styles.name}>
              <th>氏名</th>
              <td>
                <InputText
                  name="name"
                  placeholder="山田太郎"
                  value={store.form.name}
                  onChange={this.change}
                />
                {errors.name}
              </td>
            </tr>
            <tr className={styles.email}>
              <th>メールアドレス</th>
              <td>
                <p>※フリーアドレスは登録できません</p>
                <InputText
                  name="email"
                  placeholder="abc@bil.jp"
                  value={store.form.email}
                  onChange={this.change}
                />
                {errors.email}
              </td>
            </tr>
            <tr>
              <th>電話番号</th>
              <td>
                <InputText
                  name="tel"
                  placeholder="0354132411"
                  value={store.form.tel}
                  onChange={this.change}
                />
                {errors.tel}
              </td>
            </tr>
            <tr>
              <td className={styles.agree} colSpan={2}>
                <div>
                  当社の
                  <a href="https://www.bil.jp/privacy.html" target="_blank">
                    個人情報保護方針
                  </a>
                  を確認ください。
                </div>
                <div>
                  <InputCheckBox
                    id="agree"
                    name="agree"
                    value={store.form.agree}
                    onChange={this.change}
                  >
                    個人情報保護方針に同意する
                  </InputCheckBox>
                </div>
                {errors.agree}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/screens/registration/form.js